<template>
  <div class="">
    <el-upload
      :multiple="true"
      :show-file-list="true"
      class="upload-demo"
      :on-remove="handleRemove"
      :file-list="value"
      action=""
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :http-request="handleFileChange"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <!-- <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，且不超过500kb
      </div> -->
    </el-upload>
  </div>
</template>

<script>
import { guid } from '@/utils/index'
import { getUploadPresignedUrl } from '@/api/common'
export default {
  name: 'UploadDoc',
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    color: {
      type: String,
      default: '#1890ff',
    },
    // 限制上传文件类型
    accept: {
      type: String,
      default: 'image/*,video/*',
    },
    // 上传文件夹
    uploadFolder: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
  data() {
    return {
      listObj: {},
      fileList: [],
    }
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess,
      )
    },
    handleSubmit() {
      return new Promise((resolve, reject) => {
        const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
        if (!this.checkAllSuccess()) {
          this.$message(
            '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！',
          )
          return
        }
        console.log(arr)
        this.$emit('uploaddoc', arr)
        resolve()
      })
    },
    handleSuccess(response, file) {
      console.log(file)
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      console.log(objKeyArr)

      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url =
            process.env.VUE_APP_AWS_S3_DOMAIN + response.key
          this.listObj[objKeyArr[i]].hasSuccess = true
          this.listObj[objKeyArr[i]] = {
            ...this.listObj[objKeyArr[i]],
            file_name: this.listObj[objKeyArr[i]].name,
            file_path: response.key,
          }
          const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
          console.log(arr)
          this.$emit('change', this.value.concat(arr))
          return
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid
      this.value.splice(
        this.value.findIndex((item) => {
          return item.uid == uid
        }),
        1,
      )
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload(file) {
      console.log(file)
      const _URL = window.URL || window.webkitURL
      const fileName = file.uid
      this.listObj[fileName] = {}
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        name: file.name,
        width: this.width,
        height: this.height,
        size: file.size,
      }
    },
    async handleFileChange(option) {
      console.log(option)
      const file = option.file
      if (!file) {
        this.$message('获取文件信息失败')
        return
      }

      try {
        const folder = this.uploadFolder
        const fileKey = folder + file.name

        // 1. 从后端获取预签名 URL
        const res = await getUploadPresignedUrl({
          file_name: fileKey,
          mime_type: file.type,
        })
        const { upload_url, key } = res.data

        // 2. 直接 PUT 到预签名 URL
        const uploadRes = await fetch(upload_url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
            'Content-Disposition': 'inline',
          },
        })

        if (!uploadRes.ok) {
          throw new Error('上传失败')
        }

        // 3. 触发 on-success 回调，由 handleSuccess 处理状态更新
        option.onSuccess({ key: key }, file)
      } catch (error) {
        console.error('上传失败', error)
        this.$message('上传失败，请重试')
        option.onError(error)
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep.el-upload--picture-card {
    width: 100%;
  }
}
</style>
